import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../https.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactusService {

  private readonly leadsBaseUrl = 'https://sitesapi.digicoffer.com/lead';
    // private readonly leadsBaseUrl = 'http://localhost:3001/lead';


  constructor(
    private httpService: HttpService,
    private http: HttpClient
  ) {}

  getProducts(): Observable<any> {
    return this.httpService.sendReGetRequest('/products') as Observable<any>;
  }

  getLeadsByProduct(productKey: string): Observable<any> {
    return this.http.get<any>(`${this.leadsBaseUrl}/${productKey.toUpperCase()}`);
  }
}